import { Link } from 'react-router-dom';

import { IconButton, Text } from '@actualtysoft/ui-kit';
import { faBars, faCogs, faFolderOpen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import NavigationBar from 'components/Layout/NavigationBar';
import UserModal from 'components/Layout/UserModal';
import { useModalStore } from 'stores/modal';

const ProfileMenu = (): JSX.Element => {
  const { openModal } = useModalStore();
  const { breakpoints, shape, palette } = useTheme();

  return (
    <div>
      <AppBar
        position="relative"
        color="default"
        sx={{
          borderBottom: `2px solid`,
          borderColor: palette.redActual,
          background: 'white',
          boxShadow: 'none',
        }}
      >
        <Container
          sx={{ maxWidth: 'calc(100% - 200px) !important', padding: '0px' }}
        >
          <Toolbar>
            <Link
              to="/"
              style={{
                textDecoration: 'none',
                color: '#000',
              }}
            >
              <Box>
                <Grid container spacing={3} alignItems="center">
                  <Grid>
                    <FontAwesomeIcon
                      color={palette.redActual}
                      icon={faFolderOpen}
                      size="2x"
                    />
                  </Grid>
                  <Grid>
                    <Text
                      variant="h4"
                      sx={{
                        display: 'none',
                        [breakpoints.up('md')]: {
                          display: 'block',
                        },
                      }}
                    >
                      Atlas
                    </Text>
                    <Text
                      variant="body2"
                      sx={{
                        display: 'none',
                        [breakpoints.up('md')]: {
                          display: 'block',
                        },
                      }}
                    >
                      Referentiel commun
                    </Text>
                  </Grid>
                </Grid>
              </Box>
            </Link>
            <Box flexGrow={1} pl={3} display="flex" justifyContent="flex-end">
              <Box
                width={375}
                sx={{ padding: 1, borderRadius: shape.borderRadius }}
              />
            </Box>

            <Box
              sx={{
                display: 'none',
                [breakpoints.up('md')]: {
                  display: 'flex',
                },
              }}
            >
              <IconButton
                onClick={() =>
                  openModal({
                    title: 'Mon compte',
                    type: 'drawer',
                    withHeader: false,
                    component: <UserModal />,
                  })
                }
                variant="outlined"
                color="secondary"
                icon={faBars}
                size="medium"
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                [breakpoints.up('md')]: {
                  display: 'none',
                },
              }}
            >
              <IconButton
                onClick={() =>
                  openModal({
                    title: '',
                    type: 'drawer',
                    withHeader: false,
                    component: <UserModal />,
                  })
                }
                color={palette.redActual}
                size="medium"
                icon={faCogs}
              />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <NavigationBar />
    </div>
  );
};

export default ProfileMenu;
